import PropTypes from 'prop-types';

import AppHeader from '../../DevCenter/AppHeader';
import { AppHeader as AppHeaderV3 } from '../../../componentsV2/AppHeader';
import { AppContainer } from '../../../componentsV2/AppContainer';
import { EmptyState } from '../../../componentsV2/EmptyState';
import { useAppCommonsInternal } from '../../../componentsV2/AppCommonsProvider';
import { Button } from '../../../componentsV2/Button';

import styles from './DevCenterAppErrorView.scss';

import SubtitleWithIntercomLink from '~/components/EmptyView/EmptyAppView/components/ErrorSubtitleWithIntercomLink';
import { RefreshIcon } from '~/icons';

const elementsClassNames = { content: styles.appContainerContent };

const tryRenderComponent = (Component, props) => {
  try {
    return <Component {...props} />;
  } catch (e) {
    console.error(e);
    return null;
  }
};

function DevCenterAppErrorView({ appHeaderProps, openIntercom }) {
  const appCommons = useAppCommonsInternal();
  const appHeadersV3Enabled = !!appCommons?.appHeadersV3Enabled;
  const reloadApp = appCommons?.reloadApp;

  const content = (
    <EmptyState
      title="App Loading Error"
      subTitle={
        <>
          <SubtitleWithIntercomLink openIntercom={openIntercom} />
          {reloadApp && (
            <div className={styles.refresh}>
              <Button prefix={<RefreshIcon />} type="primary" onClick={reloadApp} size="large">
                Refresh App
              </Button>
            </div>
          )}
        </>
      }
      image="appLoadingError"
    />
  );

  if (appHeadersV3Enabled) {
    const appHeader = tryRenderComponent(AppHeaderV3, { disableSettings: true });
    return (
      <AppContainer header={appHeader} elementsClassNames={elementsClassNames}>
        {content}
      </AppContainer>
    );
  }

  const appHeader = tryRenderComponent(AppHeader, appHeaderProps);
  return (
    <div className={styles.container}>
      {appHeader}
      {content}
    </div>
  );
}

DevCenterAppErrorView.propTypes = {
  app: PropTypes.shape({}),
};

DevCenterAppErrorView.defaultProps = {
  app: null,
};

export default DevCenterAppErrorView;
